import { NoShowType } from '@sdk/noShows/types/NoShowType';
import { ColorPalette } from '@sdk/theme/colorsLight';
import { SickCalloutType } from '@sdk/noShows/types/SickCalloutType';

import { EventBoxColorsType } from '../types/EventBoxColorsType';

export default function getAbsenceColors(
  absence: NoShowType | SickCalloutType,
  colors: ColorPalette
): EventBoxColorsType {
  const { foreign } = absence;

  return {
    bg: foreign ? colors.unavailability : colors.absence,
    bgHover: colors.absence,
    borderColor: foreign ? colors.unavailability : colors.absence,
    borderColorHover: colors.absence,
    textColor: foreign ? colors.primaryText : colors.white,
    textColorHover: colors.white,
  };
}
